

























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Language } from "../../services/language/entities/language.interface";
import { Translate } from "../../services/language/entities/translate.interface";
import constants from "../../config/constants";

@Component
export default class CreatePostDialog extends Vue {
  @Prop() dialogCreate!: boolean;
  @Prop() page!: number;

  hosted = false;
  hostedURL = "";
  file = null;
  fileRestricted = false;
  attachedFile = null;
  link = "";
  mediaType = "";
  name: Array<Translate> = [];
  description: Array<Translate> = [];
  linkName: Array<Translate> = [];

  $refs!: {
    formCreate: HTMLFormElement;
  };

  valid = true;
  loadingCreate = false;
  snackbarSuccessCreate = false;
  snackbarErrorCreate = false;

  private getMediaFormat(event: any): void {
    if (event) {
      const file = event || event.dataTransfer.files;
      const type = file.type !== undefined ? file.type : "error/error";
      this.mediaType = type.split("/")[1].toUpperCase();
    } else {
      this.file = null;
      this.mediaType = "";
    }
  }

  private created(): void {
    this.$store.dispatch("language/getLanguages").then(() => {
      this.languages.forEach((language: Language) => {
        this.name.push({
          languageID: language.cb_language_id,
          languageName: language.cb_language_name,
          iso: language.cb_language_iso,
          text: "",
        });

        this.description.push({
          languageID: language.cb_language_id,
          languageName: language.cb_language_name,
          iso: language.cb_language_iso,
          text: "",
        });

        this.linkName.push({
          languageID: language.cb_language_id,
          languageName: language.cb_language_name,
          iso: language.cb_language_iso,
          text: "",
        });
      });
    });
  }

  private mounted(): void {
    this.file = null;
    this.hosted = false;
    this.hostedURL = "";
  }

  private cancelCreate(): void {
    this.$emit("cancelCreate");
  }

  private createPost(): void {
    const nameTranslate = this.name.map((translate: Translate) => {
      return {
        iso: translate.iso == null ? "" : translate.iso,
        text: translate.text == null ? "" : translate.text,
      };
    });
    const descriptionTranslate = this.description.map(
      (translate: Translate) => {
        return {
          iso: translate.iso == null ? "" : translate.iso,
          text: translate.text == null ? "" : translate.text,
        };
      }
    );
    const linkNameTranslate = this.linkName.map((translate: Translate) => {
      return {
        iso: translate.iso == null ? "" : translate.iso,
        text: translate.text == null ? "" : translate.text,
      };
    });
    const mediaType = this.mediaType;
    const file = this.attachedFile;
    const link = this.link;
    this.loadingCreate = true;
    this.$store
      .dispatch("post/createPost", {
        fields: [
          {
            name: "name",
            translate: nameTranslate,
          },
          {
            name: "description",
            translate: descriptionTranslate,
          },
          {
            name: "linkName",
            translate: linkNameTranslate,
          },
        ],
        mediaUrl: this.hosted ? this.hostedURL : this.file,
        mediaType: !this.hosted ? mediaType : "HOSTED",
        hosted: this.hosted,
        file: file,
        fileRestricted: this.fileRestricted,
        link: link,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE,
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessCreate = true;
        } else {
          this.snackbarErrorCreate = true;
        }

        this.loadingCreate = false;
        this.cancelCreate();
      });
  }

  private get languages(): Array<Language> {
    return this.$store.getters["language/getLanguages"];
  }
}
